export default "__VITE_ASSET__XvDAUTCd__"